'use client';

import { Children } from 'react';
import { styled } from 'styled-components';
import SplitContentPanel from '@dvd/components/SplitContentPanel';
import SplitMediaPanel from '@dvd/components/SplitMediaPanel';
import SplitCardsGrid from '@dvd/components/SplitCardsGrid';
import type { ThreeChildren, SplitMediaProps } from '@types';
import SplitGrid from '.';

type SplitSubSectionsProps = SplitMediaProps & {
  /**
   * The three BaseText children
   */
  children: ThreeChildren;
};

const SplitSubSectionsContentPanel = styled(SplitContentPanel)`
  & > :first-child {
    margin-top: ${({ theme }) => theme.spacing[1.5]};
  }

  ${({ theme }) => theme.mq.minWidth.large} {
    & > :first-child {
      margin-top: unset;
    }
  }
`;

const SplitSubSections = ({
  children,
  hashedId,
  imageAlt,
  imageHeight,
  imageSrc,
  imageWidth,
  mediaOrientation,
}: SplitSubSectionsProps) => {
  const childrenArray = Children.toArray(children);
  const baseTextChild = childrenArray[0];
  const smallBaseTextChildOne = childrenArray[1];
  const smallBaseTextChildTwo = childrenArray[2];
  return (
    <SplitGrid mediaOrientation={mediaOrientation}>
      {hashedId ? (
        <SplitMediaPanel hashedId={hashedId} />
      ) : (
        <SplitMediaPanel
          alt={imageAlt}
          height={imageHeight}
          src={imageSrc}
          width={imageWidth}
        />
      )}
      <SplitSubSectionsContentPanel>
        {baseTextChild}
        <SplitCardsGrid>
          {smallBaseTextChildOne}
          {smallBaseTextChildTwo}
        </SplitCardsGrid>
      </SplitSubSectionsContentPanel>
    </SplitGrid>
  );
};

export default SplitSubSections;
